"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_FILE_TYPES = exports.UNEXPECTED_WIDGET_ERRORS = void 0;
var override_service_1 = require("@services/overrides/override-service");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var CHECK_STATUS_DELAY = 1000;
exports.UNEXPECTED_WIDGET_ERRORS = 'There were unexpected errors in the following widgets';
var EXPORT_FILE_TYPES;
(function (EXPORT_FILE_TYPES) {
    EXPORT_FILE_TYPES["DOCX"] = "docx";
    EXPORT_FILE_TYPES["PDF"] = "pdf";
    EXPORT_FILE_TYPES["PPTX"] = "pptx";
    EXPORT_FILE_TYPES["JPEG"] = "jpg";
})(EXPORT_FILE_TYPES = exports.EXPORT_FILE_TYPES || (exports.EXPORT_FILE_TYPES = {}));
(function (module) {
    module.constant('pr.EXPORT_FILE_TYPES', EXPORT_FILE_TYPES);
    module.factory('prDownloadHelper', [
        '$http',
        '$q',
        '$filter',
        '$routeParams',
        'qstrap.modal',
        'rsEnvironment',
        'pr.API_ROUTES',
        'pr.EXPORT_FILE_TYPES',
        'prOverrideTrigger',
        'prDynamicTranslationsUtil',
        'prErrorModal',
        function ($http, $q, $filter, 
        // @ts-ignore
        $routeParams, modal, env, 
        // @ts-ignore
        API_ROUTES, 
        // @ts-ignore
        FILE_TYPES, triggerOverrides, dynamicTranslationsUtil, 
        // @ts-ignore
        errorModal) {
            var translate = $filter('translate');
            function exportReport(type, reportDownloadOptions) {
                if (reportDownloadOptions === void 0) { reportDownloadOptions = {}; }
                var options = __assign(__assign({}, reportDownloadOptions), { type: type, projectId: $routeParams.projectId || env.get(environment_1.ENV_VARS.ACTIVE_PROJECT_ID) || $routeParams.surveyId, view: 'dashboard', surveyId: $routeParams.surveyId, containerId: $routeParams.containerId, dashboardId: $routeParams.dashboardId });
                options.preview = $routeParams.preview === 'true';
                if ($routeParams.publicHash) {
                    options.publicHash = $routeParams.publicHash;
                }
                options = overrideDownloadOptions(options);
                return sendDownloadRequest(options);
            }
            function downloadDOCX() {
                return exportReport(FILE_TYPES.DOCX);
            }
            function downloadPDF(passcode) {
                return exportReport(FILE_TYPES.PDF, { passcode: passcode });
            }
            function downloadPPTX() {
                return exportReport(FILE_TYPES.PPTX, { editableWidgets: true });
            }
            function downloadWidgetImage(widgetId, widgetType) {
                var options = {
                    widgetId: widgetId,
                    widgetType: widgetType,
                    type: FILE_TYPES.JPEG,
                    surveyId: $routeParams.surveyId,
                    containerId: $routeParams.containerId,
                    isWidgetExport: true
                };
                options = overrideDownloadOptions(options);
                return sendDownloadRequest(options);
            }
            function downloadWidgetDocx(exportOptions) {
                exportOptions = lodash_1.default.assign(exportOptions, {
                    surveyId: $routeParams.surveyId,
                    containerId: $routeParams.containerId
                });
                exportOptions = overrideDownloadOptions(exportOptions);
                return sendDownloadRequest(exportOptions);
            }
            function sendDownloadRequest(options) {
                showModal();
                var config = dynamicTranslationsUtil.getLanguageHeaders();
                return $http.post(API_ROUTES.EXPORT, options, config)
                    .then(function (response) {
                    checkForFile(response.data.id, options.type);
                }).catch(closeModal);
            }
            // @ts-ignore
            var downloadModal;
            function showModal() {
                downloadModal = modal({
                    show: true,
                    title: translate('MESSAGE_EXPORT_GENERATING'),
                    content: translate('MESSAGE_EXPORT_AUTO_DOWNLOAD')
                });
            }
            function closeModal() {
                // @ts-ignore
                downloadModal.close();
            }
            function checkForFile(exportId, type, tryCount) {
                if (tryCount === void 0) { tryCount = 0; }
                var path = "" + API_ROUTES.EXPORT + exportId + "?type=" + type;
                return $http.get(path + "&try=" + tryCount).then(function (response) {
                    if (response.status === 200) {
                        closeModal();
                        downloadFile(path);
                    }
                    else {
                        setTimeout(function () {
                            checkForFile(exportId, type, ++tryCount);
                        }, CHECK_STATUS_DELAY);
                    }
                }).catch(handleFailedExport);
            }
            function downloadFile(path) {
                $('<iframe class="download-iframe" ></iframe>').attr({
                    src: path,
                    style: 'visibility:hidden; display: none;'
                }).appendTo('body');
            }
            // @ts-ignore
            function handleFailedExport(response) {
                closeModal();
                console.error('Failed to download file', response);
                var modalContent = getFailedExportModalContent(response);
                errorModal.show(modalContent, 'PR.FAILED_EXPORT_MODAL.TITLE');
            }
            // @ts-ignore
            function getFailedExportModalContent(response) {
                var errorMessage = lodash_1.default.get(response, 'data.error.error', '');
                return errorMessage.includes(exports.UNEXPECTED_WIDGET_ERRORS) ?
                    'PR.FAILED_EXPORT_MODAL.WIDGET_ERRORS' :
                    'PR.FAILED_EXPORT_MODAL.GENERIC_ERROR';
            }
            function overrideDownloadOptions(options) {
                return triggerOverrides({
                    event: override_service_1.OVERRIDE_EVENTS.DOWNLOAD_OPTIONS,
                    data: options,
                    sync: true
                });
            }
            return {
                downloadDOCX: downloadDOCX,
                downloadPDF: downloadPDF,
                downloadPPTX: downloadPPTX,
                exportReport: exportReport,
                downloadWidgetImage: downloadWidgetImage,
                downloadWidgetDocx: downloadWidgetDocx
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
